<div *ngIf="!isLoading && artistProfile">
  {{ "artist-certification.artist-profile-link.hint" | translate }}
  <a [routerLink]="artistProfileLink" class="text-as-500">{{
    "artist-certification.artist-profile-link.link" | translate
  }}</a>
</div>
